import { dateLocale } from "../i18n/dateLocale";

/**
 * A calendar day as a sentence states it: "Nov 1, 2026" / "1 nov. 2026" / "1 nov 2026".
 *
 * The month is written out on purpose. A bare `toLocaleDateString()` in the product's English
 * and French locales (en-CA, fr-CA) prints ISO "2026-11-01", which reads as a database value in
 * the middle of "Stripe bills this price from … on {date}".
 */
const DAY = { year: "numeric", month: "short", day: "numeric" };

const parsed = (value) => {
  if (!value) return null;
  const d = new Date(value);
  return Number.isNaN(d.getTime()) ? null : d;
};

/** A server timestamp (ISO-8601 instant) as the reader's calendar day; `null` when absent or unparseable. */
export const instantDay = (iso, lang) => {
  const d = parsed(iso);
  return d ? d.toLocaleDateString(dateLocale(lang), DAY) : null;
};

/**
 * A date-only value ("YYYY-MM-DD") as that same calendar day. It names a UTC day (the parser reads
 * a date-only string as UTC midnight), so it is formatted in UTC: in the browser's zone it would
 * read as the day before west of Greenwich.
 */
export const utcDay = (isoDate, lang) => {
  const d = parsed(isoDate);
  return d ? d.toLocaleDateString(dateLocale(lang), { ...DAY, timeZone: "UTC" }) : null;
};
